const styles = theme => ({
  ...theme.layout,

  panelContainer: {
    //
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  formControl: {
    gridColumn: 'span 3',

    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 6',
    },
  },

  selectInput: {
    gridColumn: 'span 3',

    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 6',
    },
  },

  input: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      fontSize: 16,
      padding: '10px 12px',
      transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    },
  },

  submitButton: {
    backgroundColor: '#315382',
    color: 'white',
    alignSelf: 'stretch',
    gridColumn: 'span 3',

    '&:hover': {
      backgroundColor: '#315382AF',
    },

    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 6',
    },
  },
});

export default styles;
